export const scaledPriceSlider = () => {
    // inspired by https://stackoverflow.com/questions/61792449/material-ui-slider-changing-values-using-scale
    console.log('function called');
    const priceSliderScale = [
        { value: 0, scaledValue: 0, label: 0 },
        { value: 20, scaledValue: 20, label: 20 },
        { value: 40, scaledValue: 40, label: 40 },
        { value: 60, scaledValue: 60, label: 60 },
        { value: 80, scaledValue: 80, label: 80 },
        { value: 100, scaledValue: 100, label: 100 },
        { value: 120, scaledValue: 200, label: 200 },
        { value: 140, scaledValue: 400, label: 400 },
    ];
    const unscaleTable = {
        0: 0,
        20: 20,
        40: 40,
        60: 60,
        80: 80,
        100: 100,
        200: 120,
        400: 140,
    };
    const scale = (value) => {
        const index = value / 20;
        return priceSliderScale[index].scaledValue;
    };
    const unscale = (scaledValue) => {
        return unscaleTable[scaledValue];
    };
    const step = 20;
    const min = 0;
    const max = 140;
    const marks = priceSliderScale;
    return { scale, unscale, min, max, step, marks };
};

export const sizeSliderRange = [];
